"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElementSize = exports.IterateEntries = exports.HandleSize = void 0;
var _array = require("../type-checks/array");
var _function = require("../type-checks/function");
var _number = require("../type-checks/number");
var _react = require("react");
const IterateEntries = (entries, method) => {
    let result = false;
    if ((0, _array.isArrayOfLength)(entries) && (0, _function.isFunction)(method)) {
      result = true;
      entries.forEach(ref => {
        method(ref);
      });
    }
    return result;
  },
  HandleSize = (height, width, setter) => {
    const result = {
      height: (0, _number.isNumber)(height) ? height : 0,
      width: (0, _number.isNumber)(width) ? width : 0
    };
    setter(result);
    return result;
  },
  /**
   * Hook to observe and notify when the boundary height/width of a node changes
   *
   * @name useElementSize
   * @returns {array} Hooks array containing useRef node placeholder and object containing height and width
   */
  useElementSize = () => {
    const [ref, setRef] = (0, _react.useState)(null),
      [size, setSize] = (0, _react.useState)({
        height: 0,
        width: 0
      }),
      observer = new ResizeObserver(entries => {
        IterateEntries(entries, handleSize);
      }),
      handleSize = (0, _react.useCallback)(() => {
        HandleSize(ref?.offsetHeight, ref?.offsetWidth, setSize);
      }, [ref?.offsetHeight, ref?.offsetWidth]);
    (0, _react.useEffect)(() => {
      if (ref) {
        observer.observe(ref);
      }
      return () => {
        if (ref) {
          observer.unobserve(ref);
        }
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]);
    (0, _react.useLayoutEffect)(() => {
      handleSize();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref?.offsetHeight, ref?.offsetWidth]);
    return [setRef, size];
  };
exports.useElementSize = useElementSize;
exports.HandleSize = HandleSize;
exports.IterateEntries = IterateEntries;